import { render } from "./accept.html?vue&type=template&id=6f60acf6&scoped=true&external"
import script from "./accept.vue?vue&type=script&lang=js"
export * from "./accept.vue?vue&type=script&lang=js"

import "./accept.vue?vue&type=style&index=0&id=6f60acf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f60acf6"]])

export default __exports__